
interface FuelGaugeProps {
  value: number;
  onChange: (value: number) => void;
}

const FuelGauge = ({ value, onChange }: FuelGaugeProps) => {

  const rotation = -90 + (value / 100) * 180;

  const getColor = () => {
    if (value < 30) return "#ff3b3b";
    if (value < 70) return "#ffcc00";
    return "#2ecc71";
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

      <svg width="200" height="120" viewBox="0 0 200 120">

        {/* arco */}
        <path
          d="M20 100 A80 80 0 0 1 180 100"
          fill="none"
          stroke="#ddd"
          strokeWidth="12"
        />

        {/* arco colorido */}
        <path
          d="M20 100 A80 80 0 0 1 180 100"
          fill="none"
          stroke={getColor()}
          strokeWidth="12"
          strokeDasharray={`${(value / 100) * 251} 251`}
        />

        {/* ponteiro */}
        <g transform={`rotate(${rotation} 100 100)`}>
          <line
            x1="100"
            y1="100"
            x2="100"
            y2="35"
            stroke="#222"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </g>

        {/* centro */}
        <circle cx="100" cy="100" r="6" fill="#222" />

        {/* textos */}
        <text x="20" y="115" fontSize="14">E</text>
        <text x="170" y="115" fontSize="14">F</text>

      </svg>

      <input
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{ width: 160, marginTop: 10 }}
      />

      <strong>{value}%</strong>

    </div>
  );
};

export default FuelGauge;